import React, {useState, useCallback} from "react";
import {Tabs} from "@shopify/polaris";
import _ from "lodash";
import DashboardDetails from "./DashboardDetails";

const MultiCurrencyDashboardDetails = ({currencies = [], abandonedCheckouts, RecoveredCheckouts, loading}) => {
    const [selected, setSelected] = useState(0);

    const handleTabChange = useCallback(
        (selectedTabIndex) => setSelected(selectedTabIndex),
        [],
    );

    const storeCurrencies = currencies.sort();
    const tabs = [];

    const getDashboardDetailsByCurrency = (currency, dashboardData) => {
        let cartDetails = dashboardData.filter(cart => {
            return (cart.presentment_currency === currency.toLowerCase() || cart.presentment_currency === currency.toUpperCase())
        })
        if (cartDetails.length > 0) {
            return cartDetails[0];
        }
        return {
            presentment_currency: currency,
            count: 0,
            total: 0.00
        };
    }

    const TabContent = ({currency}) => {
        let abandonedCheckoutDetails = getDashboardDetailsByCurrency(currency, abandonedCheckouts)
        let recoveredCheckoutDetails = getDashboardDetailsByCurrency(currency, RecoveredCheckouts)
        let data = {};
        let abandonedTotal = parseFloat(_.get(abandonedCheckoutDetails, `total`, '0.00'));
        data.totalAbandonedCheckouts = parseInt(_.get(abandonedCheckoutDetails, `count`, '0'));
        data.totalAbandonedRevenue = abandonedTotal.toFixed(2);
        let recoveredTotal = parseFloat(_.get(recoveredCheckoutDetails, `total`, '0.00'));
        data.totalRecoveredCheckouts = parseInt(_.get(recoveredCheckoutDetails, `count`, '0'));
        data.totalRecoveredRevenue = recoveredTotal.toFixed(2);
        return (<DashboardDetails loading={loading} dashboardData={data} currency={currency} width={100}/>);
    }

    for (let currency of storeCurrencies) {
        tabs.push({
            id: currency,
            content: currency.toUpperCase(),
            accessibilityLabel: currency.toUpperCase(),
            tabContent: <TabContent currency={currency}/>
        });
    }

    return (
        <div style={{ width: "50%", paddingBottom: "20px" }}>
            <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
                <div style={{marginTop: "20px"}}>
                    {tabs[selected].tabContent}
                </div>
            </Tabs>
        </div>
    );
}

export default MultiCurrencyDashboardDetails;
